import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { ProductService, ResourceItem } from '@app/services/product.service';
import { SrCrewResourceGet, SrCrewService } from '@app/services/sr-crew.service';

@Component({
    selector: 'tt-sr-crew-resource',
    templateUrl: './sr-crew-resource.component.html',
    styleUrls: ['./sr-crew-resource.component.css'],
    standalone: false,
})
export class SrCrewResourceComponent implements OnInit {
    public page?: SrCrewResourceGet;
    public saving = false;
    public deleting = false;

    constructor(
        private readonly crew: SrCrewService,
        private readonly product: ProductService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.crew.getResource({
            srcrewresource_keyno: String(this.navigator?.params['srcrewresource_keyno'] ?? '0'),
            resource_id: String(this.navigator?.params['resource_id'] ?? '0'),
            srcrew_keyno: String(this.navigator?.params['srcrew_keyno'] ?? '0'),
        });
    }

    public searchResources = (params?: { value?: string }): Promise<ResourceItem[]> =>
        this.product.searchResources({ resource_searchtext: params?.value ?? this.page?.resource_name ?? '' });

    public onResourceSelected(resource?: ResourceItem): void {
        if (!this.page) return;
        this.page.resource_id = resource?.item_id ?? '0';
        this.page.resource_name = resource?.item_name ?? '';
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving || this.deleting) return;
        this.saving = true;
        try {
            const response = await this.crew.saveResource(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting || this.saving) return;
        this.deleting = true;
        try {
            const response = await this.crew.deleteResource(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.deleting = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
